// ** Icon imports
import HomeIcon from 'mdi-material-ui/Home'

const navigation = () => {
  return [
    {
      title: 'Dashboard',
      icon: HomeIcon,
      path: '/'
    },
  ]
}

export default navigation
